import React, {useState, useCallback, useEffect} from 'react';
import {Modal} from "../../../utils/modal/Modal";
import {formatErrors, roleTechnicalSpecialist, userStatusFired} from "../../../constants";
import {useDispatch} from "react-redux";
import {toast} from "react-toastify";
import {SelectModal} from "../../../utils/select/SelectModal";
import {clientsCuratorAction} from "../../../actions/clientAction";

export function ClientsCuratorOnPageModal({users, client, trigger, handleComplete}) {
  const [open, setOpen] = useState(false);
  const [form, setForm] = useState({
    curator_from: '',
    curator_to: '',
    client_ids: [client.id]
  });
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();

  const handleOpen = (value) => {
    if (loading) {
      return;
    }
    setOpen(value);
  };

  const handleChangeForm = useCallback((e) => {
    const name = e.target.name;
    const value = e.target.value;
    setForm((form) => {
      return {...form, [name]: value}
    });
    setErrors((errors) => {
      return {...errors, [name]: value.trim() === ''}
    });
  }, []);

  const handleSubmit = () => {
    if (loading) {
      return false;
    }
    let errs = {};
    if (!form.curator_to) {
      errs.curator_to = true;
    }
    setErrors(errs);
    if (Object.keys(errs).length > 0) {
      return;
    }
    setLoading(true);
    dispatch(clientsCuratorAction(form)).then((data) => {
      setLoading(false);
      handleComplete(data.curator);
      setOpen(false);
    }).catch((e) => {
      setLoading(false);
      toast.error(formatErrors([e.message]), {position: toast.POSITION.BOTTOM_RIGHT});
    });
  };

  useEffect(() => {
    if (open) {
      setForm({
        curator_from: '',
        curator_to: '',
        client_ids: [client.id]
      });
      setErrors({});
    }
  }, [open, client]);

  return <Modal isStatic={true} open={open} handleOpen={handleOpen} trigger={trigger} triggerWrap={false}>
    <React.Fragment>
      <div className="modal__title">Сменить куратора</div>
      <div className="modal__inner">
        <SelectModal title="Передать куратору"
                     name="curator_to"
                     value={form.curator_to}
                     error={errors.curator_to}
                     disabled={loading}
                     onChange={handleChangeForm}>
          <option value="">Выберите</option>
          {
            users.map(i => i.value && (i.role_id != roleTechnicalSpecialist) && (i.status != userStatusFired) && <option key={i.value} value={i.value}>{i.text}</option>)
          }
        </SelectModal>
      </div>
      <div className="modal__btns">
        <button type="button" className="modal__btn btn" onClick={handleSubmit} disabled={loading}>Передать</button>
      </div>
    </React.Fragment>
  </Modal>
};
